import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col rounded-lg border border-lightGray30 px-3 py-3 text-left md:px-4",
  "data-testid": "station-activity-records-section"
}
const _hoisted_2 = { class: "flex flex-col gap-3" }
const _hoisted_3 = { class: "flex flex-wrap items-center justify-between gap-2" }
const _hoisted_4 = {
  class: "text-sm text-gray-500",
  "data-testid": "station-activity-records-count"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-start gap-1 text-sm text-negative",
  "data-testid": "station-activity-records-error"
}
const _hoisted_6 = {
  key: 1,
  class: "text-sm text-gray-500",
  "data-testid": "station-activity-records-loading"
}
const _hoisted_7 = {
  key: 2,
  class: "text-sm text-gray-500",
  "data-testid": "station-activity-records-empty"
}
const _hoisted_8 = { class: "flex flex-wrap items-center gap-2 border-b border-gray-30 px-3 py-2 text-sm" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-x-4 gap-y-2 px-3 py-2 text-xs md:grid-cols-4" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-500" }, "Perna cobrada", -1)
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-500" }, "Prazo", -1)
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-500" }, "Aberta em", -1)
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-500" }, "Canal", -1)
const _hoisted_19 = { class: "flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-dashed border-gray-30 px-3 py-2 text-xs text-gray-500" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "flex-1" }, "Cancelada automaticamente quando a perna for coberta por outra fonte.", -1)
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex flex-wrap items-center gap-2 border-b border-gray-30 px-3 py-2 text-sm" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Registro de Atividade", -1)
const _hoisted_24 = { class: "text-gray-500" }
const _hoisted_25 = {
  key: 2,
  class: "text-xs font-semibold text-sucess",
  "data-testid": "station-activity-record-winner"
}
const _hoisted_26 = {
  key: 3,
  class: "text-xs text-gray-500",
  "data-testid": "station-activity-record-replacement"
}
const _hoisted_27 = { class: "grid grid-cols-2 gap-x-4 gap-y-2 px-3 py-2 text-xs md:grid-cols-4" }
const _hoisted_28 = { class: "flex flex-col" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-500" }, "Tipo", -1)
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-500" }, "Perna(s)", -1)
const _hoisted_32 = { class: "flex flex-col" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold uppercase text-gray-500" }, "Anexos", -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = { class: "font-bold uppercase text-gray-500" }
const _hoisted_38 = { class: "flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-dashed border-gray-30 px-3 py-2 text-xs text-gray-500" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "flex-1" }, null, -1)
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'

import CollapsibleSection from './CollapsibleSection.vue'
import ActivityAttachmentsModal from './ActivityAttachmentsModal.vue'
import type { ActivityAttachment } from './ActivityAttachmentsModal.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { LabelBadgeColor } from '@/components/designSystem/Badges/LabelBadge.vue'
import Network from '@/Network'
import { useIsMobile } from '@/hooks/useIsMobile'
import { pathForStatus } from '@/modules/company/Approvals/DsAttendance/utils/status-route-map'
import { getApiErrorMessage, getApiErrorStatus } from '@/utils/apiError'
import { formatDayMonthInOffset, formatHourMinuteInOffset } from '@/utils/date'
import type { DSAttendanceContainer } from '@/types/ds-attendance.types'
import {
  ACTIVITY_REJECTION_REASON_LABELS,
  ACTIVITY_REQUEST_CHANNEL_LABELS,
  ACTIVITY_TYPE_LABELS,
  ActivityRejectionReason,
  ActivityRequestChannel,
  ActivityType,
  COVERED_LEGS_LABELS,
  ContainerKind,
  CoveredLegs,
  DS_ATTENDANCE_STATUS_LABELS,
  DSAttendanceStatus,
  REQUESTED_LEG_LABELS
} from '@/constants/ds-attendance.constants'

/**
 * Container de espécie `ATIVIDADE`.
 *
 * Os campos da F2 vivem no próprio `DSAttendanceContainer` (todos opcionais: o
 * backend da F2 ainda não está em produção e a tela renderiza o que vier sem
 * quebrar nem inventar). O apelido fica porque é ele que dá nome ao que este
 * componente lista.
 */
export type ActivityRecordItem = DSAttendanceContainer

/** Erros que significam "esta seção não existe para você", não "deu ruim". */
const NOT_INFORMED = 'Não informado'
const NOT_INFORMED_FEMININE = 'Não informada'

const OVERDUE_TICK_MS = 60_000

export default /*#__PURE__*/_defineComponent({
  __name: 'StationActivityRecordsSection',
  props: {
    doctorStationId: {},
    canSendRecord: { type: Boolean, default: false },
    activityRecordsEnabled: { type: Boolean, default: false },
    timezone: { default: '-03:00' },
    winningLegs: { default: () => ({}) },
    touchTarget: { type: Boolean, default: false }
  },
  emits: ["sendRecord"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;

const SILENT_ERROR_STATUSES = [401, 403, 404, 405, 501]





// Celular (QA-01): o reset do Vuetify zera `border-style` em <button>; o desktop fica como está.
const { isMobileLayout } = useIsMobile()

/**
 * A cobrança da F3 (`PENDING_SUBMISSION`) tem card PRÓPRIO: sem tipo, sem anexo e
 * sem trilha de auditoria, ela renderizada no card comum apareceria como um
 * registro "Não informado" em três das quatro colunas.
 */
const isRequest = (record: ActivityRecordItem): boolean =>
  record.status === DSAttendanceStatus.PENDING_SUBMISSION || record.isPendingRequest === true

const allRecords = ref<ActivityRecordItem[]>([])

/**
 * Só o que tem card comum. As solicitações saem daqui para `requests` — as duas
 * listas juntas são `allRecords`, e é `allRecords` que decide se a seção existe.
 */
const records = computed(() => allRecords.value.filter((record) => !isRequest(record)))
const requests = computed(() => allRecords.value.filter(isRequest))
const isLoading = ref(false)
const hasLoaded = ref(false)
const loadError = ref<string | null>(null)

const isAttachmentsModalOpen = ref(false)
const attachmentsContainerId = ref<number | null>(null)
const selectedAttachments = ref<ActivityAttachment[]>([])

// Enquanto não carregou, a seção não aparece: um acordeão que nasce fechado e
// depois "pula" para aberto quando os registros chegam é pior do que esperar.
// Sem registros e sem permissão de envio não há o que oferecer — some.
const isVisible = computed(
  () => hasLoaded.value && (allRecords.value.length > 0 || props.canSendRecord || !!loadError.value)
)

const countLabel = computed(() => {
  const parts = [records.value.length === 1 ? '1 registro' : `${records.value.length} registros`]
  if (requests.value.length) {
    parts.push(
      requests.value.length === 1
        ? '1 solicitação aberta'
        : `${requests.value.length} solicitações abertas`
    )
  }
  return parts.join(' · ')
})

async function fetchRecords() {
  const doctorStationId = props.doctorStationId
  // Feature desligada: nem `hasLoaded` — a seção não existe, e sem a marca ela
  // volta a buscar sozinha se a política for ligada enquanto o modal está aberto.
  if (!props.activityRecordsEnabled) {
    allRecords.value = []
    return
  }

  if (!doctorStationId) {
    allRecords.value = []
    hasLoaded.value = true
    return
  }

  isLoading.value = true
  loadError.value = null
  try {
    const response = await Network.dsAttendance.listByCompany({
      kind: ContainerKind.ATIVIDADE,
      doctorStationId,
      page: 1,
      limit: 50
    })
    const listed = ((response?.data ?? []) as ActivityRecordItem[]).filter(isRenderableRecord)
    allRecords.value = await withRegistrationAttachments(listed, doctorStationId)
  } catch (error) {
    allRecords.value = []
    // Sem acesso à fila (403) ou com a rota ausente (404/405/501) não há nada a
    // mostrar NEM a tentar de novo: a seção simplesmente não existe para esse
    // usuário. Banner de erro aqui viraria ruído em todo Detalhes do Plantão de
    // quem não audita registro de presença.
    if (SILENT_ERROR_STATUSES.includes(getApiErrorStatus(error) ?? 0)) {
      console.debug('[StationActivityRecords] sem acesso ou rota ausente; seção omitida', error)
    } else {
      console.error('Erro ao listar os Registros de Atividade da vaga:', error)
      loadError.value = getApiErrorMessage(
        error,
        'Não foi possível carregar os Registros de Atividade desta vaga.'
      )
    }
  } finally {
    isLoading.value = false
    hasLoaded.value = true
  }
}

/**
 * r2-m2 — o item da fila traz só `attachmentCount`; os ids dos anexos (o que o "Ver
 * anexos" precisa) vivem em `activityRecords[]` da registration do plantão. A busca só
 * acontece quando algum registro tem anexo sem id, e é best-effort: sem ela o card
 * mostra a contagem e omite o botão — nunca um botão que abre um modal vazio.
 */
async function withRegistrationAttachments(
  listed: ActivityRecordItem[],
  doctorStationId: number
): Promise<ActivityRecordItem[]> {
  const needsIds = listed.some(
    (record) => !attachmentsOf(record).length && (record.attachmentCount ?? 0) > 0
  )
  if (!needsIds) return listed

  try {
    const registration = (await Network.station.getStationRegistration(doctorStationId)) as {
      activityRecords?: Array<{
        containerId?: number | null
        attachments?: ActivityAttachment[] | null
        submittedBy?: { name?: string | null } | null
        submittedAt?: string | null
      }> | null
    } | null
    const byContainer = new Map(
      (registration?.activityRecords ?? []).map((record) => [Number(record.containerId), record])
    )
    return listed.map((record) => {
      const fromRegistration = byContainer.get(Number(record.id))
      if (!fromRegistration) return record
      return {
        ...record,
        attachments: attachmentsOf(record).length
          ? record.attachments
          : (fromRegistration.attachments ?? record.attachments),
        submittedBy: record.submittedBy ?? fromRegistration.submittedBy ?? null,
        submittedAt: record.submittedAt ?? fromRegistration.submittedAt ?? null
      }
    })
  } catch (error) {
    console.debug('[StationActivityRecords] registration indisponível; anexos só contados', error)
    return listed
  }
}

/**
 * Três filtros no cliente, os três deliberados:
 *
 * 1. `kind === 'ATIVIDADE'` — um backend anterior à F2 IGNORA o parâmetro `kind`
 *    e devolveria as folhas da empresa inteira como se fossem registros desta
 *    vaga. Sem o campo, o item simplesmente não entra.
 * 2. `doctorStationId` — o filtro vai no servidor, mas um backend que aceite
 *    `kind` e ignore a vaga mostraria registros de OUTRA alocação dentro do
 *    Detalhes do Plantão. Quando o item diz a que vaga pertence, conferimos;
 *    quando o campo não vem (fora do contrato da F2), confiamos no servidor —
 *    descartar tudo esconderia registros legítimos por um campo de projeção.
 * 3. `PENDING_SUBMISSION` fora — é a solicitação automática da F3, que tem card
 *    próprio e ainda não existe.
 */
function isRenderableRecord(record: ActivityRecordItem): boolean {
  if (record.kind !== ContainerKind.ATIVIDADE) return false
  if (
    record.doctorStationId !== null &&
    record.doctorStationId !== undefined &&
    Number(record.doctorStationId) !== Number(props.doctorStationId)
  ) {
    return false
  }
  return true
}

function statusLabel(record: ActivityRecordItem): string {
  return DS_ATTENDANCE_STATUS_LABELS[record.status] ?? String(record.status ?? '—')
}

function statusColor(record: ActivityRecordItem): LabelBadgeColor {
  if (record.status === DSAttendanceStatus.APPROVED) return 'green'
  if (record.status === DSAttendanceStatus.REJECTED) return 'red'
  return 'orange'
}

/**
 * Fallback de campo vazio, em duas formas porque concorda com o substantivo do rótulo
 * ao lado: "Tipo", "Trecho coberto", "Motivo" e "Canal" são masculinos; "Equivalência",
 * "Perna solicitada" e "Abertura", femininos. Unificar numa forma só (ou num "—")
 * mudaria o texto que a tela mostra hoje, então ficam as duas.
 *
 * Local ao arquivo como nos componentes irmãos da mesma feature
 * (`DsAttendanceActivityAudit.vue`, `DsAttendanceAwaitingAudit.vue`).
 */
function typeLabel(record: ActivityRecordItem): string {
  if (record.activityTypeLabel) return record.activityTypeLabel
  const type = record.activityType as ActivityType | undefined
  return (type && ACTIVITY_TYPE_LABELS[type]) || NOT_INFORMED
}

function legsLabel(record: ActivityRecordItem): string {
  const legs = record.coveredLegs as CoveredLegs | undefined
  return (legs && COVERED_LEGS_LABELS[legs]) || NOT_INFORMED
}

function attachmentsOf(record: ActivityRecordItem): ActivityAttachment[] {
  return record.attachments ?? []
}

/** Ids quando vieram; senão a contagem do item da fila (`attachmentCount`). */
function attachmentCountOf(record: ActivityRecordItem): number {
  return attachmentsOf(record).length || record.attachmentCount || 0
}

function equivalenceTitle(record: ActivityRecordItem): string {
  return record.status === DSAttendanceStatus.REJECTED ? 'Motivo' : 'Equivalência'
}

function equivalenceLabel(record: ActivityRecordItem): string {
  if (record.status === DSAttendanceStatus.REJECTED) {
    const reason = record.rejectionReason as ActivityRejectionReason | undefined
    return (reason && ACTIVITY_REJECTION_REASON_LABELS[reason]) || NOT_INFORMED
  }

  const parts = [
    legTimeLabel('Check-in', record.appliedCheckin ?? record.declaredCheckin),
    legTimeLabel('Check-out', record.appliedCheckout ?? record.declaredCheckout)
  ].filter(Boolean)

  return parts.length ? parts.join(' · ') : NOT_INFORMED_FEMININE
}

function legTimeLabel(prefix: string, iso?: string | null): string | null {
  if (!iso) return null
  const time = formatHourMinuteInOffset(iso, props.timezone)
  return time ? `${prefix} ${time}` : null
}

function trailLabel(record: ActivityRecordItem): string {
  // r2-m1 — o item da fila serve o emissor achatado (`submittedByName`); o objeto
  // `submittedBy` só vem da registration. Um ou outro, nunca "não identificado" com nome.
  const submitted = personAndDate(
    'Enviado por',
    record.submittedBy?.name ?? record.submittedByName,
    record.submittedAt
  )
  const reviewedPrefix =
    record.status === DSAttendanceStatus.REJECTED ? 'Reprovado por' : 'Auditado por'
  const reviewed = personAndDate(reviewedPrefix, record.reviewedBy?.name, record.reviewedAt)
  const parts = [submitted, reviewed].filter(Boolean)
  return parts.length ? parts.join(' · ') : 'Sem trilha de auditoria'
}

function personAndDate(prefix: string, name?: string | null, iso?: string | null): string | null {
  if (!name && !iso) return null
  const when = iso ? formatDayMonthInOffset(iso, props.timezone) : null
  const time = iso ? formatHourMinuteInOffset(iso, props.timezone) : null
  const whenLabel = when && time ? ` em ${when} ${time}` : ''
  return `${prefix} ${name || 'não identificado'}${whenLabel}`
}

/**
 * Textos do card de solicitação (F3). Todos com fallback: `requestedLeg` e
 * `requestChannel` são colunas da F3 e saem `null` num backend anterior — o card
 * ainda assim precisa dizer o que é e oferecer o CTA.
 */
function requestTitle(record: ActivityRecordItem): string {
  const leg = record.requestedLeg ? REQUESTED_LEG_LABELS[String(record.requestedLeg)] : null
  return leg
    ? `Solicitação: ${leg.toLowerCase()} sem registro`
    : 'Solicitação de Registro de Atividade'
}

function requestedLegLabel(record: ActivityRecordItem): string {
  const leg = record.requestedLeg
  return (leg && REQUESTED_LEG_LABELS[String(leg)]) || NOT_INFORMED_FEMININE
}

function deadlineLabel(record: ActivityRecordItem): string {
  const iso = record.expectedSubmissionAt
  if (!iso) return 'Sem prazo definido'
  const day = formatDayMonthInOffset(iso, props.timezone)
  return day ? `vence ${day}` : 'Sem prazo definido'
}

function openedAtLabel(record: ActivityRecordItem): string {
  const iso = record.createdAt ?? record.submittedAt
  if (!iso) return NOT_INFORMED_FEMININE
  const day = formatDayMonthInOffset(iso, props.timezone)
  const time = formatHourMinuteInOffset(iso, props.timezone)
  return day && time ? `${day} ${time}` : (day ?? NOT_INFORMED_FEMININE)
}

function channelLabel(record: ActivityRecordItem): string {
  const channel = record.requestChannel as ActivityRequestChannel | undefined
  return (channel && ACTIVITY_REQUEST_CHANNEL_LABELS[channel]) || NOT_INFORMED
}

/**
 * Relógio reativo do selo "Vencida". `Date.now()` direto no render não é
 * reativo: um modal aberto por horas nunca passava a marcar o vencimento que
 * aconteceu enquanto ele estava na tela.
 */
const now = ref(Date.now())
let overdueTimer: ReturnType<typeof setInterval> | null = null

onMounted(() => {
  overdueTimer = setInterval(() => {
    now.value = Date.now()
  }, OVERDUE_TICK_MS)
})

onBeforeUnmount(() => {
  if (overdueTimer) clearInterval(overdueTimer)
  overdueTimer = null
})

/** Vencida é a solicitação cujo prazo já passou — a F3 não tem campo próprio. */
function isOverdue(record: ActivityRecordItem): boolean {
  const iso = record.expectedSubmissionAt
  return !!iso && new Date(iso).getTime() < now.value
}

/**
 * "venceu a perna de check-out" (M1, Tela 1). Só o registro por perna sabe disso:
 * um registro APROVADO pode ter perdido o ranking para a folha, e anunciar
 * vitória pelo status seria mentira na tela mais consultada do painel.
 */
function winningLegLabel(record: ActivityRecordItem): string | null {
  const legs: string[] = []
  if (props.winningLegs.checkin && Number(props.winningLegs.checkin) === Number(record.id)) {
    legs.push('check-in')
  }
  if (props.winningLegs.checkout && Number(props.winningLegs.checkout) === Number(record.id)) {
    legs.push('check-out')
  }
  if (!legs.length) return null
  return legs.length === 1 ? `venceu a perna de ${legs[0]}` : 'venceu as duas pernas'
}

/**
 * O registro reprovado aponta para quem o substituiu e o novo aponta de volta (Q20/Q33).
 * Desde 2026-10-01 o Receptor Avançado pode reverter a reprovação, mas o rótulo
 * "substituído por #…" segue correto: havendo reenvio, o backend bloqueia o revert.
 * Sem as duas pontas o gestor não sabe se a recusa foi resolvida.
 */
function replacementLabel(record: ActivityRecordItem): string | null {
  const successor = allRecords.value.find(
    (item) => Number(item.previousContainerId ?? 0) === Number(record.id)
  )
  if (successor) return `substituído por #${successor.id}`
  if (record.previousContainerId) return `referencia #${record.previousContainerId}`
  return null
}

function openAttachments(record: ActivityRecordItem) {
  attachmentsContainerId.value = record.id
  selectedAttachments.value = attachmentsOf(record)
  isAttachmentsModalOpen.value = true
}

/**
 * M1-2: "Abrir na fila de auditoria" vai para o card na fila unificada em NOVA
 * ABA — o gestor não perde o contexto da vaga que está analisando.
 */
function openInQueue(record: ActivityRecordItem) {
  window.open(queuePath(record), '_blank', 'noopener,noreferrer')
}

/**
 * Rota pelo MAPA canônico (`status-route-map`), nunca por um `if` local: o card
 * de SOLICITAÇÃO é `PENDING_SUBMISSION` por construção, e o `if` de dois braços
 * mandava o gestor para a auditoria pendente de um container ainda não enviado.
 */
function queuePath(record: ActivityRecordItem): string {
  return pathForStatus(record.id, record.status)
}

watch(
  // A feature entra no watch: a política da escala chega DEPOIS do primeiro
  // render (o modal busca `registration-settings` em paralelo), e sem ela aqui a
  // seção nunca buscaria nada.
  () => [props.doctorStationId, props.activityRecordsEnabled] as const,
  () => {
    hasLoaded.value = false
    allRecords.value = []
    fetchRecords()
  },
  { immediate: true }
)

__expose({ fetchRecords })

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CollapsibleSection, {
          title: "Registros de Atividade da vaga",
          "test-id": "station-activity-records-accordion",
          "touch-target": _ctx.touchTarget,
          "expand-label": "Ver registros de atividade",
          "collapse-label": "Ocultar registros de atividade"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(countLabel.value), 1),
                (_ctx.canSendRecord)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(["rounded border border-primary30 px-3 py-1.5 text-sm font-semibold text-primary30 hover:bg-primary5", { 'border-solid': _unref(isMobileLayout) }]),
                      "data-testid": "station-activity-records-send-record",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('sendRecord')))
                    }, " Enviar registro ", 2))
                  : _createCommentVNode("", true)
              ]),
              (loadError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(loadError.value), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "font-semibold underline",
                      "data-testid": "station-activity-records-retry",
                      onClick: fetchRecords
                    }, " Tentar novamente ")
                  ]))
                : (isLoading.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Carregando registros…"))
                  : (!allRecords.value.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Nenhum Registro de Atividade nesta vaga."))
                    : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value, (request) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: `request-${request.id}`,
                  class: "rounded border border-dashed border-alert bg-orange-50",
                  "data-testid": "station-activity-request-card"
                }, [
                  _createElementVNode("header", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(requestTitle(request)), 1),
                    _createVNode(LabelBadge, {
                      label: "Aguardando envio",
                      color: "orange",
                      size: "small",
                      icon: null
                    }),
                    (isOverdue(request))
                      ? (_openBlock(), _createBlock(LabelBadge, {
                          key: 0,
                          label: "Vencida",
                          color: "red",
                          size: "small",
                          icon: null,
                          "data-testid": "station-activity-request-overdue"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("span", null, _toDisplayString(requestedLegLabel(request)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("span", null, _toDisplayString(deadlineLabel(request)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", null, _toDisplayString(openedAtLabel(request)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("span", null, _toDisplayString(channelLabel(request)), 1)
                    ])
                  ]),
                  _createElementVNode("footer", _hoisted_19, [
                    _hoisted_20,
                    (_ctx.canSendRecord)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "font-semibold text-primary30 underline",
                          "data-testid": "station-activity-request-send-record",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('sendRecord')))
                        }, " Enviar registro "))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "font-semibold text-primary30 underline",
                      "data-testid": "station-activity-record-open-queue",
                      onClick: ($event: any) => (openInQueue(request))
                    }, " Abrir na fila de auditoria ", 8, _hoisted_21)
                  ])
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, (record) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: record.id,
                  class: _normalizeClass(["rounded border border-gray-30", record.legacyMigrated ? 'border-dashed bg-gray-50' : 'bg-white']),
                  "data-testid": "station-activity-record-card"
                }, [
                  _createElementVNode("header", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("span", _hoisted_24, "#" + _toDisplayString(record.id), 1),
                    _createVNode(LabelBadge, {
                      label: statusLabel(record),
                      color: statusColor(record),
                      size: "small",
                      icon: null,
                      "data-testid": "station-activity-record-status"
                    }, null, 8, ["label", "color"]),
                    (record.afterClosure)
                      ? (_openBlock(), _createBlock(LabelBadge, {
                          key: 0,
                          label: "Recebido após fechamento",
                          color: "orange",
                          size: "small",
                          icon: null,
                          "data-testid": "station-activity-record-after-closure"
                        }))
                      : _createCommentVNode("", true),
                    (record.legacyMigrated)
                      ? (_openBlock(), _createBlock(LabelBadge, {
                          key: 1,
                          label: "Migrado da Avaliação de Evidências",
                          color: "gray",
                          size: "small",
                          icon: null,
                          "data-testid": "station-activity-record-legacy"
                        }))
                      : _createCommentVNode("", true),
                    (winningLegLabel(record))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(winningLegLabel(record)), 1))
                      : _createCommentVNode("", true),
                    (replacementLabel(record))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(replacementLabel(record)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("span", null, _toDisplayString(typeLabel(record)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("span", null, _toDisplayString(legsLabel(record)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      (attachmentCountOf(record))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(attachmentCountOf(record)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_35, "—"))
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("span", _hoisted_37, _toDisplayString(equivalenceTitle(record)), 1),
                      _createElementVNode("span", null, _toDisplayString(equivalenceLabel(record)), 1)
                    ])
                  ]),
                  _createElementVNode("footer", _hoisted_38, [
                    _createElementVNode("span", null, _toDisplayString(trailLabel(record)), 1),
                    _hoisted_39,
                    (attachmentsOf(record).length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "font-semibold text-primary30 underline",
                          "data-testid": "station-activity-record-view-attachments",
                          onClick: ($event: any) => (openAttachments(record))
                        }, " Ver anexos ", 8, _hoisted_40))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "font-semibold text-primary30 underline",
                      "data-testid": "station-activity-record-open-queue",
                      onClick: ($event: any) => (openInQueue(record))
                    }, " Abrir na fila de auditoria ", 8, _hoisted_41)
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["touch-target"]),
        _createVNode(ActivityAttachmentsModal, {
          modelValue: isAttachmentsModalOpen.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isAttachmentsModalOpen).value = $event)),
          "container-id": attachmentsContainerId.value,
          attachments: selectedAttachments.value
        }, null, 8, ["modelValue", "container-id", "attachments"])
      ]))
    : _createCommentVNode("", true)
}
}

})